import { customersModalActionsListners } from "./modal-actions/customers-modal-actions";
import { requestsModalActionsListners } from "./modal-actions/requests-modal-actions";
import { visitsModalActionsListners } from "./modal-actions/visits-modal-actions";
import { jobsModalActionsListners } from "./modal-actions/jobs-modal-actions";
import { quotesModalActionsListners } from "./modal-actions/quotes-modal-actions";
import { invoicesModalActionsListners } from "./modal-actions/invoices-modal-actions";
import { paymethodsModalActionsListners } from "./modal-actions/payments-modal-actions";
import { employeesModalActionsListners } from "./modal-actions/employees-modal-actions";
import { emailCampaignsModalActionsListners } from "../email-templating/modal-actions/email-campaigns-actions";
import { workersTargetsModalActionsListners } from "./modal-actions/worker-targets-actions";
import { systemEmailsModalActionsListners } from "../email-templating/modal-actions/system-emails-actions";
import { ordersModalActionsListners } from "./modal-actions/orders-modal-actions";

const handlers = {
    customersModalActionsListners,
    requestsModalActionsListners,
    visitsModalActionsListners,
    jobsModalActionsListners,
    quotesModalActionsListners,
    invoicesModalActionsListners,
    paymethodsModalActionsListners,
    employeesModalActionsListners,
    emailCampaignsModalActionsListners,
    workersTargetsModalActionsListners,
    systemEmailsModalActionsListners,
    ordersModalActionsListners
}

export const EntityModalWindow = (() => {

    let instance = null;

    return class EntityModalWindow {
        constructor(entityClassName) {
            if (instance === null) {
                instance = this;
            }
            this.entityClassName = entityClassName;
            this.modalHover();
            return instance;
        }

        modalHover() {

            $(`body.data-view.${this.entityClassName}`).off();
            $('body').on('click', `.data-view.${this.entityClassName} table td.additional:not([disabled])`, (e) => { // setup updated hovers
                //console.log('additional modal');
                $(`.modal-window-actions`).not(`.${this.entityClassName}`).addClass('d-none').removeClass('d-flex');

                const target = $(e.target).parents('.data-row').find('.additional');
                const modalWindow = $(`.modal-window-actions.${this.entityClassName}`);

                this.showOrHide(modalWindow, target);
                this.setListnersOnCurentSection(this.entityClassName, target, modalWindow);

            });
        }

        showOrHide = (modalWindow, target) => {
            if (modalWindow.hasClass('d-flex')) {
                modalWindow.addClass('d-none');
                modalWindow.removeClass('d-flex');

                if(target.find('.additional-icon').hasClass('hover')) {
                    target.find('.additional-icon').removeClass('hover');
                    return;
                }
                $('.additional-icon').removeClass('hover');
            } else {
                modalWindow.removeClass('d-none');
                modalWindow.addClass('d-flex');
            }

            const top = target.find('.additional-icon').offset().top + 30;
            const right = window.innerWidth - target.find('.additional-icon')[0].getBoundingClientRect().right;

            modalWindow.css({
                'opacity': 1,
                'display': 'flex',
                'right': right,
                'top': top,
            });

            const popupOffset = modalWindow[0].getBoundingClientRect();

            if (popupOffset.height + popupOffset.top > window.innerHeight + window.scrollY / 4) {
                modalWindow.css({
                    'right': right + 40,
                    'top': window.innerHeight + window.scrollY - popupOffset.height - 20
                });
            }

            target.find('.additional-icon').addClass('hover');
        }

        setListnersOnCurentSection = (section, target, modalWindow) => {
            const sectionWords = section.split('-');
            let methodPrefix = '';

            for (let word of sectionWords) {
                if (sectionWords.indexOf(word) == 0) {
                    methodPrefix += word;
                    continue;
                } else {
                    methodPrefix += word.charAt(0).toUpperCase() + word.slice(1);
                }

            }

            const methodName = methodPrefix + 'ModalActionsListners';
            handlers[methodName](target, modalWindow, null, this);

            //$(`.data-view .modal-window-actions.${this.entityClassName}`).off();
            $(`.data-view.${this.entityClassName}`).off('click', `.modal-window-actions.${this.entityClassName} .action`).on('click', `.modal-window-actions.${this.entityClassName} .action`, () => {
                $(`.modal-window-actions.${this.entityClassName}`).addClass('d-none').removeClass('d-flex');
            });
        }
    }
})();
